<template>
  <v-container fluid class="theme-color" style="height: 100%; overflow-x:scroll;">
    <RailReport />
  </v-container>
</template>

<script>
import RailReport from '../components/rail-executive/RailReport.vue';

export default {
  name: 'RailExecutive',
  components: {
    RailReport
  },
  data: () => ({}),
  mounted() {
    this.$emit('gobacktolink', 'report-executive');
  },
  methods: {}
};
</script>
